import { Component, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import PlayRecovery from './PlayRecovery'

type Props = { children: ReactNode; resetKey: string; panel?: { open: boolean; close: () => void } }
class ErrorBoundary extends Component<Props, { failed: boolean; resetKey: string }> {
  state = { failed: false, resetKey: this.props.resetKey }
  static getDerivedStateFromError() {
    return { failed: true }
  }
  static getDerivedStateFromProps(props: Props, state: { resetKey: string }) {
    return props.resetKey !== state.resetKey ? { failed: false, resetKey: props.resetKey } : null
  }
  render() {
    return this.state.failed ? <PlayRecovery panel={this.props.panel} /> : this.props.children
  }
}
export default function PlayErrorBoundary({ children, panel }: Omit<Props, 'resetKey'>) {
  const location = useLocation()
  return (
    <ErrorBoundary resetKey={panel ? 'panel' : location.pathname} panel={panel}>
      {children}
    </ErrorBoundary>
  )
}
